var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.798 14.962C7.009 14.1-.431 5.811 2.673 3.308c.153-.124.333-.202.524-.24.92-.186 3.767-.29 5.823 4.772 0 0 2.085-7.149 5.014-5.629 2.919 1.515 3.502 7.025-6.083 12.77a.12.12 0 0 1-.153-.02"
  })));
};
export default SvgHeart;